import chroma from "chroma-js";
import colors from "../colors";

export const getContrastTextColor = (bgColor: string): string => {
  return chroma(bgColor).luminance() > 0.4 ? colors.black900 : colors.white900;
};